import React, { Component } from 'react';
import { BodyText } from './components/Core/TextComponents';
import './index.css';

class EventPage extends Component {
    state = {
        event: null,
        loading: true,
        error: false,
    };

    componentDidMount() {
        this.loadEvent();
    }

    componentDidUpdate() {
        const currentRef = this.getEventRef();
        if (currentRef !== this.state.loadedRef) {
            this.loadEvent();
        }
    }

    getEventRef = () => decodeURIComponent(window.location.pathname.replace(/^\/event\//, '').replace(/\/$/, ''));

    loadEvent = () => {
        const ref = this.getEventRef();
        this.setState({ loading: true, error: false, loadedRef: ref });

        fetch('/data/events.json')
            .then((response) => {
                if (!response.ok) throw new Error('Event data could not be loaded');
                return response.json();
            })
            .then((events) => {
                const event = events[ref] || Object.values(events).find((value) => value.slug === ref);
                this.setState({ event: event || null, loading: false, error: !event });
                document.title = event ? `${event.name} | ai-BIBLE` : 'Event | ai-BIBLE';
            })
            .catch(() => this.setState({ loading: false, error: true }));
    };

    renderList = (title, items, renderItem) => {
        if (!items?.length) return null;

        return (
            <section className="event-page-section">
                <h2>{title}</h2>
                <div className="event-page-list">
                    {items.map(renderItem)}
                </div>
            </section>
        );
    };

    render() {
        const { event, loading, error } = this.state;

        if (loading) return <main className="event-page event-page-state">Loading event…</main>;
        if (error || !event) return <main className="event-page event-page-state"><h1>Event not found</h1></main>;

        const date = event.startDate || (event.minYear ? `${event.minYear} BC` : '');
        const metadata = [event.group, date, event.duration].filter(Boolean).join(' · ');

        return (
            <main className="event-page">
                <header className="event-page-hero">
                    <div className="event-page-hero-strip" />
                    <div>
                        <span className="event-page-eyebrow">Bible event</span>
                        <h1>{event.name}</h1>
                        {metadata ? <p>{metadata}</p> : null}
                    </div>
                </header>
                <section className="event-page-overview">
                    <span className="event-page-section-label">Overview</span>
                    <h2>{event.description}</h2>
                    <BodyText>
                        This event is part of the biblical timeline and is connected to the people, places,
                        and passages below.
                    </BodyText>
                </section>
                <div className="event-page-grid">
                    {this.renderList('People involved', event.participants, (person) => (
                        <div className="event-page-item" key={person.ref}>
                            <strong>{person.name}</strong>
                            {person.gender ? <span>{person.gender}</span> : null}
                        </div>
                    ))}
                    {this.renderList('Places', event.places, (place) => (
                        <div className="event-page-item" key={place.ref}>
                            <strong>{place.name}</strong>
                        </div>
                    ))}
                </div>
                {this.renderList('Related passages', event.verses, (verse) => (
                    <a className="event-page-item event-page-link" href={`/read/${verse.osisRef}/`} key={verse.ref}>
                        <strong>{verse.osisRef}</strong>
                        {verse.text ? <span>{verse.text}</span> : null}
                    </a>
                ))}
                <p className="event-page-credit">
                    Event timeline data from Theographic Bible Metadata, used under CC BY-SA 4.0.
                </p>
            </main>
        );
    }
}

export default EventPage;
